import { defineMessages } from 'react-intl-next';

export default defineMessages({
    defaultMappingToggleLabel: {
        defaultMessage: 'Allow default mapping',
        description: 'Toggle label for default mapping',
        id: 'sync.project.toggle.label.non-final',
    },
    removeMappingModalTitle: {
        defaultMessage: 'Stop automatically linking projects?',
        description: 'removeMapping modal title',
        id: 'sync.project.toggle.removeMapping.modal.title.non-final',
    },
    removeMappingModalDesc: {
        defaultMessage: 'New projects and their resources will not be automatically linked to this help center',
        description: 'removeMapping modal description',
        id: 'sync.project.toggle.removeMapping.modal.description.non-final',
    },
    removeMappingModalConfirmButton: {
        defaultMessage: 'Confirm',
        description: 'removeMapping modal confirm button',
        id: 'sync.project.toggle.removeMapping.modal.confirm.non-final',
    },
    removeMappingModalCancelButton: {
        defaultMessage: 'Cancel',
        description: 'removeMapping modal cancel button',
        id: 'sync.project.toggle.removeMapping.modal.cancel.non-final',
    },
    syncErrorTitle: {
        defaultMessage: 'Operation failed',
        description: 'Sync new projects flag error title',
        id: 'sync.project.toggle.sync.flag.error.title.non-final',
    },
    syncErrorDescription: {
        defaultMessage: 'Check your connection and try again.',
        description: 'Sync new projects flag error description',
        id: 'sync.project.toggle.sync.flag.error.description.non-final',
    },
});
